module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-70x70-f0302ecb1c8ba0b29c49b33ade4e8389.png";